import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ForYouIf() {
  const points = ['Sos psicólogo/a o terapeuta y trabajás, o querés trabajar, con adultos mayores.', 'Querés saber qué evaluar desde la primera consulta con un geronte.', 'Te cuesta diferenciar tristeza, duelo, aislamiento, pérdida de autonomía o deterioro cognitivo leve.', 'Buscás un sistema práctico, profesional y aplicable desde el primer día.'];
  return <section className="w-full py-16 md:py-24 bg-[#faf9f7]" data-id="element-53">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-bold text-[#14505c] mb-8 text-center" data-id="element-56">
            ESTE KIT ES PARA VOS SI...
          </h2>
          <div className="bg-white p-8 md:p-12 rounded-lg shadow-md" data-id="element-57">
            <ul className="space-y-4" data-id="element-58">
              {points.map((point, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} className="flex items-start gap-3" data-id="element-59">
                  <Check className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" data-id="element-60" />
                  <span className="text-gray-700" data-id="element-61">{point}</span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}